import { gql } from '@apollo/client';

import {
  WITH_COUNT_VARIABLES,
  WITH_COUNT_ARGUMENTS
} from '../../../queries/withCount';

import { CORE_ASSET_FIELDS } from 'app/src/components/Assets/queries';

const ERRORS = `errors { path, message }`;

const EXPENSE_LINE_FIELDS = `
  id
  asset { id, name}
  saleAsset {
    id
    lotNumber
    sale { id , name, saleOn }
  }
  amount
  description
`

const EXPENSE_LINE_VARIABLES = `
  $assetId: ID!
  $saleAssetId: ID
  $amount: Decimal!
  $description: String
`;

const EXPENSE_LINE_ARGUMENTS = `
  assetId: $assetId
  saleAssetId: $saleAssetId
  amount: $amount
  description: $description
`;

const EXPENSE_LINE_FIELDS_AND_ERRORS = `
  expenseLine {
    ${EXPENSE_LINE_FIELDS}
  }
  ${ERRORS}
`;

export const EXPENSE_LINES_WITH_COUNT = gql`
  query (
    ${WITH_COUNT_VARIABLES}
    $assetId: ID
  ) {
    expenseLinesWithCount(
      ${WITH_COUNT_ARGUMENTS}
      assetId: $assetId
    ) {
      entries {
        ${EXPENSE_LINE_FIELDS}
      }
      count
    }
  }
`;

export const CREATE_EXPENSE_LINE = gql`
  mutation CreateExpenseLine(
    $expenseId: ID!
    ${EXPENSE_LINE_VARIABLES}
  ) {
    createExpenseLine(
      expenseId: $expenseId
      ${EXPENSE_LINE_ARGUMENTS}
    ) {
      expenseLine {
        id
        amount
        description
        asset {
          ${CORE_ASSET_FIELDS}
          seller { name }
        }
      }
      errors { path, message }
    }
  }
`;

export const UPDATE_EXPENSE_LINE = gql`
  mutation UpdateExpenseLine(
    $id: ID!
    ${EXPENSE_LINE_VARIABLES}
  ) {
    updateExpenseLine(
      id: $id
      ${EXPENSE_LINE_ARGUMENTS}
    ) {
      ${EXPENSE_LINE_FIELDS_AND_ERRORS}
    }
  }
`;

export const EXPENSE_LINE = gql`
  query ExpenseLine($id: ID!) {
    expenseLine(id: $id) {
      ${EXPENSE_LINE_FIELDS}
    }
  }
`;

export const SELECTS = gql`
  query SelectOptions($assetId: ID) {
    saleAssetOptions(assetId: $assetId) {
      id
      sale { id, name, saleOn }
      status
      lotNumber
    }
  }
`

